import WebApp from "../components/WebApp";

const Proposal = () => {
  return (
    <WebApp>
      <div>
          Proposal
      </div>
    </WebApp>
  );
};


export default Proposal;